import { useEffect, useState } from 'react';

/**
 * The value as it settles: it follows `value` only after `delay` ms without a
 * change. Autocompletes use it so a lookup request goes out once the user
 * pauses, not on every keystroke.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    if (value === settled) return;
    const timer = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay, settled]);

  return settled;
}
